export const facultyCopy = {
  title: "Faculty",
  job: "Find an instructor and read their teaching assignments.",
  find: "Search faculty",
  empty: "No faculty profiles yet.",
  failed: "The faculty directory could not be read.",
  assignments: "Teaching assignments",
  noAssignments: "No teaching assignments recorded.",
  profile: "Profile",
  open: "Open profile",
  teaching: "Teaching",
  unassigned: "Unassigned",
  noSpecialization: "No specialization on file",
  facts: { honorific: "Honorific", title_role: "Title", specialization: "Specialization", training_chain: "Training chain", email: "Contact email" },
};
